import React, { useEffect, useRef } from 'react';
import cn from 'classnames';

const TextAutoScroll = ({
  className,
  children
}) => {
  const intervalId = useRef(null);
  const textRef = useRef(null);
  const interval = () => {
    intervalId.current = setInterval(() => {
      if (textRef.current) {
        const scrollDist = (textRef.current?.scrollLeft) || 0;
        const totalDist = +(textRef.current?.scrollWidth - textRef.current?.clientWidth) || 0;
        const percentageScroll = +((5 * totalDist) / 100);
        if (!totalDist) {
          clearInterval(intervalId.current);
        } else if (scrollDist < totalDist) {
          textRef.current.scrollLeft += percentageScroll;
        } else {
          clearInterval(intervalId.current);
          textRef.current.scrollLeft += percentageScroll;
          setTimeout(() => {
            if (textRef.current) {
              textRef.current.scrollTo(0, 0);
            }
            return interval();
          }, 1000);
        }
      }
    }, 200);
  };
  useEffect(() => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
    }
    interval();
    return () => {
      clearInterval(intervalId.current);
    };
  }, [children]);
  return (
    <div ref={textRef} className={cn(className, 'maxW-100 overflowX text-nowrap scrollSmooth')}>
      {children}
    </div>
  );
};

export default TextAutoScroll;
